import { localeDefault } from "@app/config/constants";

type Options = { date?: boolean; time?: boolean };

/**
 * Formats a date to a human-readable string, using the browser's locale.
 */
export default function formatDate(date: Date, options: Options = { date: true, time: true }): string {
  return new Intl.DateTimeFormat(localeDefault, {
    dateStyle: options.date ? "medium" : undefined,
    timeStyle: options.time ? "short" : undefined
  }).format(date);
}
